const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080';

type LoginParams = { email: string; password: string };

async function request(path: string, options: RequestInit = {}) {
  const headers: Record<string, string> = {
    'Accept': 'application/json',
    ...(options.headers as Record<string, string> || {}),
  };

  // withCredentials equivalent for fetch — sends httpOnly auth_token cookie automatically
  const res = await fetch(`${API_URL}${path}`, { ...options, headers, credentials: 'include' });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Solicitud fallida');
  }
  try {
    return await res.json();
  } catch {
    return {};
  }
}

export default {
  login: ({ email, password }: LoginParams) => {
    return request('/api/v1/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
  },

  getPatients: (_token: string, params: Record<string, string | number | undefined> = {}) => {
    const q = new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => {
      if (v !== undefined && v !== null) acc[k] = String(v);
      return acc;
    }, {} as Record<string, string>)).toString();
    return request(`/api/v1/patients?${q}`);
  },
};

export { request };
